import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";
import { useSiatMotion } from "./motion";

export function Hero() {
  const { t } = useTranslation("global");
  const { fadeUp, scaleIn, stagger } = useSiatMotion();

  return (
    <header className="siat-hero" id="top">
      <div
        className="siat-hero__bg"
        aria-hidden="true"
        style={{ backgroundImage: "url(/img/city.jpg)" }}
      />
      <div className="siat-hero__shade" aria-hidden="true" />

      <div className="siat-hero__frame">
        <motion.div
          className="siat-hero__product"
          variants={scaleIn}
          initial="hidden"
          animate="show"
        >
          <div className="siat-hero__glow" aria-hidden="true" />
          <img
            className="siat-hero__phone"
            src="/img/phone1-cut.png"
            alt={t("hero.mockupAlt")}
            width="581"
            height="1180"
          />
        </motion.div>

        <motion.div
          className="siat-hero__copy"
          variants={stagger}
          initial="hidden"
          animate="show"
        >
          <motion.h1 variants={fadeUp}>{t("hero.brand")}</motion.h1>
          <motion.p className="siat-hero__banner-line" variants={fadeUp}>
            {t("hero.bannerLine")}
          </motion.p>
          <motion.p className="siat-hero__tagline" variants={fadeUp}>
            {t("hero.tagline")}
          </motion.p>
          <motion.div className="siat-cta-row" variants={fadeUp}>
            <a className="siat-btn siat-btn--primary" href="#download">
              {t("hero.ctaDownload")}
            </a>
            <a className="siat-btn siat-btn--ghost" href="#contact">
              {t("hero.ctaSectors")}
            </a>
          </motion.div>
        </motion.div>
      </div>
    </header>
  );
}
